import axios from 'axios'
import { demoAdapter } from '@/demo/api.cjs'

// 운영 주소와 인증정보를 사용하지 않는다. 미지원 요청도 네트워크로 전달하지 않는다.
const httpClient = axios.create({ adapter: demoAdapter })
httpClient.interceptors.response.use(response => {
  if (response.data.resultCode === 'DEMO_DISABLED') {
    window.dispatchEvent(new CustomEvent('demo-disabled', { detail: response.data.resultMessage }))
  }
  return response
})
export default httpClient
